<template>
  <div class="outer-container custom_dark_blue_bg">
    <div class="container">
      <h2 class="heading_fonts text-center pb-4 custom_white">
        The Requirements For Upskill Assessment test & Bootcamp
      </h2>

      <div class="grid">
        <div class="">
          <img
            src="../../../assets/homeV2/Recruiter/Frame (2).png"
            class="mx"
            alt=""
          />
        </div>
        <div class="">
          <div class="flex">
            <ol>
              <li>
                <h3 class="manrope custom_white">
                  Timeline (Timing of hiring)
                </h3>
              </li>
              <li>
                <h3 class="manrope custom_white">
                  Job description
                </h3>
              </li>

              <li>
                <h3 class="manrope custom_white">
                  Number of candidate company wants to interview
                </h3>
              </li>
              <li>
                <h3 class="manrope custom_white">
                  Picture and Quote of Someone from the Company including its
                  logo
                </h3>
              </li>
            </ol>
          </div>
          <div class="">
            <a
              href="mailto:upskill@upskillbangladesh.com"
              target="_blank"
              class="btn"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
ol {
  list-style-position: outside;
  margin-bottom: 0;
  padding-left: 0px;
}
ol li {
  font-size: 24px;
  font-family: 'Manrope';
}
.btn {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  color: #2465f3 !important;
  text-align: center;
  max-width: 240px;
  min-height: 65px;
  color: white;
  cursor: pointer;
}
a {
  text-transform: capitalize;
  font-family: 'Manrope';
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 24px;
}
.container {
  max-width: 1300px;
}
.mx {
  max-height: 540px;
  max-width: 365px;
}
.grid {
  display: grid;
  grid-gap: 70px;
  grid-template-columns: 1.6fr 3fr;
  padding-top: 70px;
}
.outer-container {
  padding: 100px 0;
}
.heading_fonts {
  font: 800 2.1rem/2.3rem 'Manrope';
  letter-spacing: -2%;
}
.flex {
  display: flex;
  color: white;
}

@media (max-width: 767.98px) {
  .mx {
    max-height: 400px;
    max-width: 290px;
  }
  .grid {
    grid-gap: 30px;
    grid-template-columns: 1fr;
    padding-top: 70px;
  }
}
</style>
